module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/flow_img04-be2fc67575b3ffb2632889b298bd1e08.svg";